// web_common_department_list 获取部门列表,无参

const __request = require(`@/lib/data-service/default/__request/__request_contentType_form`);

// 接口地址：http://192.168.0.15:8080/doc.html#/所有接口/department-controller/getAllDepartmentUsingPOST

export default function web_common_department_list(pParameter) {
  if (!pParameter) pParameter = {};

  let params = {}
  params.method = 'POST'
  params.urlSuffix = '/web/common/department/list'
  params.data = pParameter
  return new Promise(function (resolve, reject) {
    resolve(__request(params))
  })
}

